import React, { Component, Fragment } from 'react';
import classnames from 'classnames/bind';

import { sections, colors } from './constants';

import Icon from 'foundations/Icons/Icon';
import CopyToClipboard from '@components/CopyToClipboard/CopyToClipboard';
import Tooltip from 'elements/Tooltip/Tooltip';
import { ListElement } from 'elements/Tooltip/Layout';

import styles from './Colors.css';

/*
  Presentational component for Colors
*/
class Colors extends Component {
  renderSection = () => {
    return (
      sections.map((section, i) =>
        <article key={i} className={styles.section}>
          <h2 className="h2 page-subtitle">{section.title}</h2>
          <ul className={styles.list}>
            { section.colors.map((color, i) => this.renderColorList(colors[color], i)) }
          </ul>
        </article>
      )
    );
  }

  renderColorList = (set, i) => {
    const cx = classnames.bind(styles);

    return (
      <Fragment key={`${set}-${i}`}>
        {set.map((color, i) =>
          <li className={styles.itemWrapper} key={`${color}-${i}`}>
            <div className={styles.tint} style={{ backgroundColor: color.hex }}>
              <CopyToClipboard
                dataText={color.class}
                customClasses={styles.clipboard}
                render={
                  (copied) =>
                    <Tooltip
                      target={
                        <Icon
                          icon={copied ? 'confirmation' : 'duplicate'}
                          type={'20'}
                          customClasses={cx({ 'active': copied })} />
                      }
                      open={copied}
                      placement={'top'}
                    >
                      <ListElement>Variable Copied!</ListElement>
                    </Tooltip>
                }
              />
            </div>
            <div className={styles.details}>
              <p className={classnames('p small', styles.colorName)}>{color.name}</p>
              <p className={classnames('tag', styles.colorCode)}>{color.hex}</p>
            </div>
          </li>
        )}
      </Fragment>
    );
  };

  render() {
    return (
      <section>
        {this.renderSection(sections)}
      </section>
    );
  }
}

export default Colors;



// WEBPACK FOOTER //
// ./src/containers/foundations/Colors/Colors.js